let bodyScrollLockCount = 0;
let bodyScrollOriginalOverflow: string | null = null;

export function lockBodyScroll() {
  if (typeof document === "undefined") {
    return;
  }

  if (bodyScrollLockCount === 0) {
    bodyScrollOriginalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
  }

  bodyScrollLockCount += 1;
}

export function unlockBodyScroll() {
  if (typeof document === "undefined" || bodyScrollLockCount === 0) {
    return;
  }

  bodyScrollLockCount -= 1;

  if (bodyScrollLockCount === 0) {
    document.body.style.overflow = bodyScrollOriginalOverflow ?? "";
    bodyScrollOriginalOverflow = null;
  }
}
